import React from "react";
import "./css/page.css";
import "./css/rsvp_module.css";
import "./css/modal.css";
// import queryString from 'query-string';
import { EventDetails, EarlyAccessProducts } from "./components";
import { AppHeader, AppFooter } from "./layouts";
import isCompleteStep from "./helpers/isCompleteStep";

// const params = queryString.parse(window.location.search);

export default class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCompleteStep: isCompleteStep()
    };
  }

  componentDidMount() {
    window.addEventListener(
      "hashchange",
      this.locationChanged.bind(this),
      false
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      "hashchange",
      this.locationChanged.bind(this),
      false
    );
  }

  locationChanged() {
    this.setState({
      isCompleteStep: isCompleteStep()
    });
  }

  render() {
    // const prefix = this.props.children.props.locale;

    return (
      <div>
        <AppHeader openLanguageSwitcher={this.props.openLanguageSwitcher} />
        <EventDetails />
        {this.props.children}
        {/* {!this.state.isCompleteStep && <EarlyAccessProducts />} */}
        <AppFooter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Page.js